<template>
  <el-table
    v-if="!loading && tableData.length > 0"
    height="100%"
    :data="tableData"
    style="width: 100%"
  >
    <template>
      <el-table-column label="名称" prop="name" width="220"> </el-table-column>
      <el-table-column
        v-for="(item, index) in tab"
        :key="index"
        :prop="item.prop"
        :label="item.title"
      >
        <template v-if="item.children&&item.children.length>0">
          <el-table-column
            v-for="(sub, i) in item.children"
            :key="i"
            :prop="sub.prop"
            :label="sub.title"
          >
          </el-table-column>
        </template>
      </el-table-column>
    </template>
  </el-table>
  <div v-else class="row-center tip">
    <img v-if="loading" src="../../../assets/img/loading.png" class="loading" />
    <img v-else src="../../../assets/img/not_found_data.png" alt="" />
  </div>
</template>

<script>
import { planAndReality } from "../../../api/power";
import {
  dateFormat,
  dayStart,
  dayEnd,
  addDay,
  getAppointedDate,
} from "../../../util/DateUtil";
import { floatFormat } from "../../../util/MathUtil";
import exportExcel from "../../../util/excel";
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'
export default {
  name: "PowerRange",
  props: {
    loops: Array,
    range: String,
    date: Date,
    node: Number,
  },
  data() {
    return {
      loading: false,
      show: true,
      tableData: [],
    };
  },
  computed: {
    selProjectName() {
      return this.$store.getters.selProjectInfo.projectName;
    },
    propsData() {
      return [this.range, this.date, this.loops, this.node];
    },
    tab() {
      if (this.node == 0) {
        return [
          {
            title: "电",
            children: [
              {
                title: "计划",
                prop: "energy_plan",
              },
              {
                title: "实际",
                prop: "energy_reality",
              },
            ],
          },
          {
            title: "水",
            children: [
              {
                title: "计划",
                prop: "water_plan",
              },
              {
                title: "实际",
                prop: "water_reality",
              },
            ],
          },
          {
            title: "热",
            children: [
              {
                title: "计划",
                prop: "heat_plan",
              },
              {
                title: "实际",
                prop: "heat_reality",
              },
            ],
          },
          {
            title: "冷",
            children: [
              {
                title: "计划",
                prop: "cooling_plan",
              },
              {
                title: "实际",
                prop: "cooling_reality",
              },
            ],
          },
        ];
      } else {
        return [
          {
            title: "电",
            prop: "energy_reality",
          },
          {
            title: "水",
            prop: "water_reality",
          },
          {
            title: "热",
            prop: "heat_reality",
          },
          {
            title: "冷",
            prop: "cooling_reality",
          },
        ];
      }
    },
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
  },
  watch: {
    propsData(n, o) {
      this.GetPlan();
    },
    node() {},
    diagramStatus(n){
				if(this.$route.query.uid === 'Range' ){
					if(n.type === 'excel' && this.tableData.length > 0){

						let data = [
							['名称'],
              ['名称']
						]
            let merges = [
							// {s: {r: 0, c: 0}, e: {r: 1, c: 0}},
						]
              if(this.node == 0){
                merges = [
                  {s: {r: 0, c: 0}, e: {r: 1, c: 0}},
                ]
                this.tab.forEach((d, i) => {
                    data[0].push(d.title,null)
                    data[1].push(d.children[0].title, d.children[1].title)
                    merges.push({s: {r: 0, c: 1 + i * 2}, e: {r: 0, c: 2 + i * 2}})
                })
                this.tableData.forEach(d => {
                  data.push([
                    d.name, 
                    d.energy_plan,
                    d.energy_reality,
                    d.water_plan,
                    d.water_reality,
                    d.heat_plan,
                    d.heat_reality,
                    d.cooling_plan,
                    d.cooling_reality,
                  ])
                })
              }else{
                data = [
                  ['名称']
                ]
                this.tab.forEach((d, i) => {
                  data[0].push(d.title)
                })
                this.tableData.forEach(d => {
                  data.push([
                    d.name, 
                    d.energy_reality,
                    d.water_reality,
                    d.heat_reality,
                    d.cooling_reality,
                  ])
                })
                
              }

						
						// exportExcel(data, '计划与实际能耗报表', merges)
            const workbook = new ExcelJS.Workbook();
						// 创建带有红色标签颜色的工作表
						const sheet = workbook.addWorksheet('Sheet1');

						let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI']
						
            let sheetName = ["计划与实际能耗报表",this.selProjectName,'日期：'+dateFormat("YY-mm", new Date(this.date))]

            let style =  {
              fill: {
                type: 'gradient',
                gradient: 'angle',
                degree: 0,
                stops: [
                  { position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
                  { position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
                  { position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
                ]
              },
              font20:{
                  name: 'Arial',
                  size: 20,
                  bold: true
              },
              font12bold:{
                name: 'Arial',
                size: 12,
                bold: true
              },
              font12:{
                name: 'Arial',
                size: 12,
                // bold: true
              },
              alignmentCenter:{ vertical: 'middle', horizontal: 'center' },
              alignmentLeft:{ vertical: 'middle', horizontal: 'left' },
              border:{
                top: {style:'thin'},
                left: {style:'thin'},
                bottom: {style:'thin'},
                right: {style:'thin'}
              }
            }
            
            if(this.node == 0){
              letter = letter.filter((e,i)=>i<9)
            }else{
              letter = letter.filter((e,i)=>i<5)
            }

            //处理一二层
            
              sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
              sheet.getCell(letter[0]+'1').value = sheetName[0]
              sheet.getCell(letter[0]+'1').font = style.font20
              sheet.getCell(letter[0]+'1').alignment = style.alignmentCenter
            
              sheet.mergeCells('A2:B2');
              sheet.mergeCells('C2:'+letter[letter.length-1]+'2');
              sheet.getCell('A2').value = sheetName[1]
              sheet.getCell('C2').value = sheetName[2]
              sheet.getRow(2).font=style.font12bold
              sheet.getRow(2).alignment = style.alignmentLeft
              const rows = sheet.getRows(1, 2);
              rows.map(e=>{e.height = 50 ;return e})

              if(this.node == 0){

              sheet.addRow(data[0]);
              sheet.addRow(data[1]);
              sheet.mergeCells('A3:A4');
              sheet.mergeCells('B3:C3');
              sheet.mergeCells('D3:E3');
              sheet.mergeCells('F3:G3');
              sheet.mergeCells('H3:I3');
              sheet.getCell('B3').value = '电';
              sheet.getCell('D3').value = '水';
              sheet.getCell('F3').value = '热';
              sheet.getCell('H3').value = '冷';
              
              
              //表格头部样式
              let num = [3,4]
              letter.forEach(item=>{
                num.forEach(elm=>{
                  sheet.getRow(elm).height = 59
                  sheet.getRow(elm).font=style.font12bold
                  sheet.getRow(elm).alignment = style.alignmentCenter
                  sheet.getCell(item+elm).fill = style.fill;
                  sheet.getCell(item+elm).border = style.border
                })
              })
              data.slice(2).forEach((item,index)=>{
                sheet.addRow(item);
                sheet.getRow(5+index).height = 38
                sheet.getRow(5+index).font=style.font12
                letter.forEach((e,i)=>{
                  sheet.getColumn(e).width = 20
                  sheet.getCell(e+(5+index)).border = style.border
                })
                sheet.getRow(5+index).alignment = style.alignmentCenter
              })
            }else{
              //表格设置
              let columns = []
              data[0].forEach(item=>{
                columns.push({
                  name:item,
                })
              })
              sheet.addTable({
                name: 'MyTable',
                ref: 'A3', // 表格左上角的位置
                headerRow: true,
                totalsRow: false,
                style: {
                  theme: 'TableStyleLight1',
                  font:{
                    name: 'Arial',
                    size: 12,
                  },
                },
                columns:columns,
                rows: data.slice(1),
              })
              //表格头部样式
              sheet.getRow(3).height = 59
              sheet.getRow(3).font=style.font12bold
              letter.forEach(item=>{
                sheet.getCell(item+'3').fill = style.fill
                sheet.getCell(item+'3').border = style.border
                sheet.getRow(3).alignment = style.alignmentCenter
              })
              data.slice(1).forEach((item,index)=>{
                sheet.getRow(4+index).height = 38
                sheet.getRow(4+index).font=style.font12
                letter.forEach((e,i)=>{
                  sheet.getColumn(e).width = 40
                  sheet.getCell(e+(4+index)).border = style.border
                })
                sheet.getRow(4+index).alignment = style.alignmentCenter
              })
            }
						// workbook.xlsx.writeFile('test.xlsx')
						workbook.xlsx.writeBuffer().then(buffer => {
							FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
						})
					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
  },
  mounted() {
    this.GetPlan();
  },
  methods: {
    //计划与实际
    async GetPlan() {
      this.loading = true;
      let currList = this.loops;
      let promises = [];
      currList.forEach((element) => {
        let obj = {
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          buildingIds: element.id,
          projectId: this.$store.state.project.currentProject.projectId,
        };
        promises.push(planAndReality(obj));
      });
      let list = [];
      Promise.all(promises).then((res) => {
        let pointsArray = res.map((r) =>
          r.data.data.list[0] ? r.data.data.list[0] : []
        );
        pointsArray.forEach((item, index) => {
            list.push({
              name: currList[index].name,
              energy_plan: item.plan&&item.plan.electric?item.plan.electric.toFixed(2)+" kWh":'--',
              energy_reality: item.reality.power.toFixed(2)+" kWh",
              heat_plan: item.plan&&item.plan.heat?item.plan.heat.toFixed(2)+" GJ":'--',
              heat_reality: item.reality.heat.toFixed(2)+" GJ",
              water_plan: item.plan&&item.plan.water?item.plan.water.toFixed(2)+" m³":'--',
              water_reality: item.reality.water.toFixed(2)+" m³",
              cooling_plan: item.plan&&item.plan.cooling?item.plan.cooling.toFixed(2)+" GJ":'--',
              cooling_reality: item.reality.cooling.toFixed(2)+" GJ",
            });
        });
        this.loading = false;
        this.tableData = list;
      });
    },
  },
};
</script>

<style scoped lang="less">
.tip {
  width: 100%;
  height: 100%;
  font-size: 16rem;
  color: #8c939d;
}

.loading {
  width: 28rem;
  height: 28rem;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
